import { render, staticRenderFns } from "./DriverChat.vue?vue&type=template&id=00f81731&scoped=true&"
import script from "./DriverChat.vue?vue&type=script&lang=js&"
export * from "./DriverChat.vue?vue&type=script&lang=js&"
import style0 from "./DriverChat.vue?vue&type=style&index=0&id=00f81731&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f81731",
  null
  
)

export default component.exports